import React, { CSSProperties, useEffect, useState } from "react";
import { clsx } from "clsx";
import {
  ensureIcoMoonStylesheet,
  isIcoMoonStylesheetReady,
} from "@src/lib/icomoon-stylesheet";

interface IRisingSunIconProps {
  icon: string;
  className?: string;
  style?: CSSProperties;
  size?: number;
  color?: string;
}

const RisingSunIcon = (props: IRisingSunIconProps) => {
  const { className, icon, size, color, style } = props;
  const [ready, setReady] = useState<boolean>(() => isIcoMoonStylesheetReady());

  useEffect(() => {
    let cancelled = false;
    ensureIcoMoonStylesheet().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <span
      aria-hidden={!ready || undefined}
      style={{
        ...style,
        fontSize: size,
        lineHeight: `${size}px`,
        height: size,
        color,
        visibility: ready ? undefined : "hidden",
      }}
      className={clsx(`icon-${icon}`, className)}
    ></span>
  );
};

export default RisingSunIcon;
